import React, { useEffect, useState } from "react";
import axios from "axios";

export default function Users() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    load();
  }, []);

  async function load() {
    const token = localStorage.getItem("token");
    const res = await axios.get("https://api.gutgeht.de/api/users", {
      headers: { Authorization: "Bearer " + token }
    });
    setUsers(res.data);
  }

  return (
    <div style={{ padding: 40 }}>
      <h2>Users</h2>
      <ul>
        {users.map(u => (
          <li key={u.id}>{u.email} — {u.role}</li>
        ))}
      </ul>
    </div>
  );
}
function connectEbay() {
  window.location.href = "/api/ebay/auth";
}
<button onClick={connectEbay}>Connect to eBay</button>
